import { render, staticRenderFns } from "./deletewatermark.vue?vue&type=template&id=86cf93d0&scoped=true&"
import script from "./deletewatermark.vue?vue&type=script&lang=js&"
export * from "./deletewatermark.vue?vue&type=script&lang=js&"
import style0 from "./deletewatermark.vue?vue&type=style&index=0&id=86cf93d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cf93d0",
  null
  
)

export default component.exports